import React, { useState,useRef, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import {
  AppBar, Toolbar, Typography, Container, CssBaseline, ThemeProvider,
  Box, TextField, Button, MenuItem, Divider, Paper, CircularProgress, Alert
} from '@mui/material';
import { createTheme } from '@mui/material/styles';
import Footer from '../pages/Footer';
import logo from '../logo.png';
import axios from 'axios';

const defaultTheme = createTheme({
  palette: {
    primary: { main: 'rgb(18,82,166)' },
    background: { default: '#eef2f5' },
  },
  typography: {
    fontFamily: '"Times New Roman", Times, serif',
  },
});

export default function ForgotUsernamePage() {
  const [firstName, setFirstName] = useState('');
  const [fathersName, setFathersName] = useState('');
  const [university, setUniversity] = useState('');
  const [department, setDepartment] = useState('');
  const [universities, setUniversities] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [username, setUsername] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const recaptchaRef = useRef(null);

  useEffect(() => {
    axios.get('https://exam.ethernet.edu.et/api/universities')
      .then(res => setUniversities(res.data));
    axios.get('https://exam.ethernet.edu.et/api/departments')
      .then(res => setDepartments(res.data));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUsername(null);
    setError('');
    setLoading(true);
  
    try {
      // Get token from invisible reCAPTCHA
      const token = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset(); // reset for next use
  
      const res = await axios.post('https://exam.ethernet.edu.et/api/forgot-username', {
        firstName,
        fathersName,
        university,
        department,
        recaptcha_token: token, 
      });
  
      if (res.data?.username) {
        setUsername(res.data.username);
      } else if (res.data?.error) {
        setError(res.data.error);
      } else {
        setError('Profile not found. Please check your information.');
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <AppBar position="static" elevation={1}>
          <Toolbar>
            <img src={logo} alt="Ministry of Education Logo" style={{ maxHeight: '70px', marginRight: '20px' }} />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              Ministry of Education
            </Typography>
          </Toolbar>
        </AppBar>

        <Container component="main" sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', my: 6 }}>
          <Box sx={{ maxWidth: 520, width: '100%' }}>
            <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
              <Typography variant="h5" align="center" gutterBottom>
                <b>Forgot Username</b>
              </Typography>
              <Typography variant="body1" align="center" color="text.secondary" sx={{ mb: 3 }}>
                Enter your academic info to recover your account username.
              </Typography>

              <Divider sx={{ mb: 3 }} />

              <form onSubmit={handleSubmit}>
                <TextField fullWidth label="First Name" required value={firstName}
                  onChange={(e) => setFirstName(e.target.value)} sx={{ mb: 2 }} size="medium" />
                <TextField fullWidth label="Father's Name" required value={fathersName}
                  onChange={(e) => setFathersName(e.target.value)} sx={{ mb: 2 }} size="medium" />

                <TextField
                  select fullWidth required label="University" value={university}
                  onChange={(e) => setUniversity(e.target.value)} sx={{ mb: 2 }} size="medium"
                >
                  {universities.map((u) => (
                    <MenuItem key={u.id} value={u.id}>{u.name}</MenuItem>
                  ))}
                </TextField>

                <TextField
                  select fullWidth required label="Department" value={department}
                  onChange={(e) => setDepartment(e.target.value)} sx={{ mb: 2 }} size="medium"
                >
                  {departments.map((d) => (
                    <MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>
                  ))}
                </TextField>

                {loading && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                    <CircularProgress size={28} />
                  </Box>
                )}

                  {!loading && username && (
                    <Alert severity="success" sx={{ mt: 2 }}>
                      ✅ Your username is: <strong>{username}</strong><br />
                      Please make sure to <strong>note it down</strong> or <strong>save it securely</strong>.
                      You’ll need it to log in and complete your registration.
                    </Alert>
                  )}


                {!loading && error && (
                  <Alert severity="error" sx={{ mt: 2 }}>
                    {error}
                  </Alert>
                )}

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                <Button variant="contained" href="/" disabled={loading}>
                  Back
                </Button>
                <Button type="submit" variant="contained" disabled={loading}>
                  {loading ? 'Please wait...' : 'Get Username'}
                </Button>
              </Box>

              </form>
            </Paper>
          </Box>
        </Container>

        <Footer />
        <ReCAPTCHA
            sitekey="6LepLRQrAAAAAGsabsOe4cjcNnm61WG8fuFvuIUq"   
            size="invisible"
  ref={recaptchaRef}
/>

      </Box>
    </ThemeProvider>
  );
}
